import React from 'react';
import SidebarCategory from './sidebar/SidebarCategory';
import QualitySignals from './sidebar/QualitySignals';
import SidebarContainer from '../../../components/sideBar/SidebarContainer';

const Sidebar = () => {
    return (
        <SidebarContainer>
            <SidebarCategory />
            <QualitySignals />
        </SidebarContainer>
    );
};

export default Sidebar;
